module.exports = "/fonts/Montserrat-Italic.ttf?6786546363c0261228fd66d68bbf27e9";